import Vue from 'vue';
import { assign } from 'lodash';
import * as apiPublic from 'api/api-public';
import * as apiPersonal from 'api/api-personal';
import * as apiAuthentication from 'api/api-authentication';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saved: false,
  saveError: null,
  error: null,
  notFound: null,
  meta: {},
  data: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saved: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = assign({}, initState);

const getters = {
  PersonalProfile: state => state,
};

const actions = {
  GetPersonalProfile({ commit }) {
    commit(types.FETCH_PERSONAL_PROFILE_START);
    apiPersonal.getProfile(
      (response) => {
        commit(types.RECEIVE_PERSONAL_PROFILE, { response });
      },
      (description, status, error) => {
        if (status === 404) {
          commit(types.FETCH_PERSONAL_PROFILE_NOT_FOUND, { error });
        } else {
          commit(types.FETCH_PERSONAL_PROFILE_ERROR, { error });
        }
      },
    );
  },
  GetPersonalPublicProfile({ commit }, query) {
    query = query || {};

    commit(types.FETCH_PERSONAL_PROFILE_START);
    apiPublic.getPublicProfile(
      query,
      (response) => {
        commit(types.RECEIVE_PERSONAL_PROFILE, { response });
      },
      (description, status, error) => {
        if (status === 404) {
          commit(types.FETCH_PERSONAL_PROFILE_NOT_FOUND, { error });
        } else {
          commit(types.FETCH_PERSONAL_PROFILE_ERROR, { error });
        }
      },
    );
  },
  PreLoginPersonalProfile({ commit }, query) {
    commit(types.FETCH_PRE_LOGIN_PERSONAL_PROFILE_START);

    apiAuthentication.authPreLogin(
      query,
      (response) => {
        commit(types.RECEIVE_PRE_LOGIN_PERSONAL_PROFILE, { response });
      },
      (description, status, error) => {
        if (status === 404) {
          commit(types.FETCH_PRE_LOGIN_PERSONAL_PROFILE_NOT_FOUND, { error });
        } else {
          commit(types.FETCH_PRE_LOGIN_PERSONAL_PROFILE_ERROR, { error });
        }
      },
    );
  },
  SavePersonalProfile({ commit }, params) {
    return new Promise((resolve, reject) => {
      const payload = params.payload;
      commit(types.SAVE_PERSONAL_PROFILE_START);
      console.log('save data', params);
      apiPersonal.updateProfile(
        payload,
        (response) => {
          console.log('save');
          commit(types.SAVE_PERSONAL_PROFILE_SUCCESSFUL, { response });
          resolve(true);
        },
        (error, status, saveError) => {
          console.log('error', status, saveError);
          commit(types.SAVE_PERSONAL_PROFILE_ERROR, { saveError });
          reject(error);
        },
      );
    });
  },
  SavePersonalProfilePicture({ commit }, params) {
    return new Promise((resolve, reject) => {
      const file = params.file;
      commit(types.SAVE_PERSONAL_PROFILE_PICTURE_START);
      console.log('save data SavePersonalProfilePicture', params);
      apiPersonal.setProfilePicture(
        file,
        (response) => {
          console.log('save SavePersonalProfilePicture');
          commit(types.SAVE_PERSONAL_PROFILE_PICTURE_DONE, { response });
          resolve(true);
        },
        (error, status, saveError) => {
          console.log('error', status, saveError);
          commit(types.SAVE_PERSONAL_PROFILE_PICTURE_ERROR, { saveError });
          reject(error);
        },
      );
    });
  },
  RemovePersonalProfilePicture({ commit }) {
    return new Promise((resolve, reject) => {
      commit(types.REMOVE_PERSONAL_PROFILE_PICTURE_START);
      apiPersonal.removeProfilePicture(
        () => {
          commit(types.REMOVE_PERSONAL_PROFILE_PICTURE_DONE);
          resolve(true);
        },
        (error, status, saveError) => {
          console.log('error', status, saveError);
          commit(types.REMOVE_PERSONAL_PROFILE_PICTURE_ERROR, { saveError });
          reject(error);
        },
      );
    });
  },
  ChangePersonalProfileEmail({ commit }, params) {
    const email = params.email;
    const emailVerified = params.email_verified;
    commit(types.CHANGE_PERSONAL_PROFILE_EMAIL, { email, emailVerified });
  },
  PersonalDeactivateAccount({ commit }, params) {
    return new Promise((resolve, reject) => {
      const payload = params.payload;

      commit(types.PERSONAL_DEACTIVATE_ACCOUNT_START);
      apiPersonal.deactivateAccount(
        payload,
        (response) => {
          commit(types.PERSONAL_DEACTIVATE_ACCOUNT_DONE, { response });
          resolve(true);
        },
        (error, status, saveError) => {
          commit(types.PERSONAL_DEACTIVATE_ACCOUNT_ERROR, { saveError });
          reject(error);
        },
      );
    });
  },
  ClearPersonalProfile({ commit }) {
    commit(types.CLEAR_PERSONAL_PROFILE_STORE);
  },
};

const mutations = {
  [types.FETCH_PERSONAL_PROFILE_START](state) {
    assign(state, neutralState, { fetching: true });
  },
  [types.FETCH_PERSONAL_PROFILE_ERROR](state, { error }) {
    assign(state, neutralState, { error });
  },
  [types.FETCH_PERSONAL_PROFILE_NOT_FOUND](state) {
    assign(state, neutralState, { notFound: true });
  },
  [types.RECEIVE_PERSONAL_PROFILE](state, { response }) {
    assign(state, neutralState, { ready: true, data: response.data, meta: response.meta });
  },

  [types.CLEAR_PERSONAL_PROFILE_STORE](state) {
    assign(state, initState);
  },

  [types.SAVE_PERSONAL_PROFILE_START](state) {
    assign(state, neutralState, { saving: true });
  },
  [types.SAVE_PERSONAL_PROFILE_ERROR](state, { saveError }) {
    assign(state, neutralState, { saveError });
  },
  [types.SAVE_PERSONAL_PROFILE_SUCCESSFUL](state, { response }) {
    assign(state, neutralState, { saved: true, data: response.data, meta: response.meta });
  },

  [types.SAVE_PERSONAL_PROFILE_PICTURE_START](state) {
    assign(state, neutralState, { saving: true });
  },
  [types.SAVE_PERSONAL_PROFILE_PICTURE_ERROR](state, { saveError }) {
    assign(state, neutralState, { saveError });
  },
  [types.SAVE_PERSONAL_PROFILE_PICTURE_DONE](state, { response }) {
    assign(state, neutralState, { saved: true });
    Vue.set(state.data, 'ProfilePicture', response.data);
  },

  [types.REMOVE_PERSONAL_PROFILE_PICTURE_START](state) {
    assign(state, neutralState, { saving: true });
  },
  [types.REMOVE_PERSONAL_PROFILE_PICTURE_ERROR](state, { saveError }) {
    assign(state, neutralState, { saveError });
  },
  [types.REMOVE_PERSONAL_PROFILE_PICTURE_DONE](state) {
    assign(state, neutralState, { saved: true });
    Vue.set(state.data, 'ProfilePicture', null);
  },
  [types.CHANGE_PERSONAL_PROFILE_EMAIL](state, { email, emailVerified }) {
    assign(state, neutralState, { saved: true });
    if (email) Vue.set(state.data, 'email', email);
    Vue.set(state.data, 'email_verified', emailVerified);
  },

  [types.FETCH_PRE_LOGIN_PERSONAL_PROFILE_START](state) {
    assign(state, neutralState, { fetching: true });
  },
  [types.FETCH_PRE_LOGIN_PERSONAL_PROFILE_ERROR](state, { error }) {
    assign(state, neutralState, { error, data: {} });
  },
  [types.FETCH_PRE_LOGIN_PERSONAL_PROFILE_NOT_FOUND](state) {
    assign(state, neutralState, { notFound: true, data: {} });
  },
  [types.RECEIVE_PRE_LOGIN_PERSONAL_PROFILE](state, { response }) {
    assign(state, neutralState, { ready: true, data: response.data, meta: response.meta });
  },

  [types.PERSONAL_DEACTIVATE_ACCOUNT_START](state) {
    assign(state, neutralState, { saving: true });
  },
  [types.PERSONAL_DEACTIVATE_ACCOUNT_ERROR](state, { saveError }) {
    assign(state, neutralState, { saveError });
  },
  [types.PERSONAL_DEACTIVATE_ACCOUNT_DONE](state) {
    assign(state, initState);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/personal/entities/personal-profile.js